import create from 'zustand'
import { persist } from 'zustand/middleware'

interface NewAccountState {
  step: number
  userData: any
  responsibleData: any
  businessData: any
  setStep: (step: number) => void
  setUserData: (data: any) => void
  setResponsibleData: (data: any) => void
  setBusinessData: (data: any) => void
  reset: () => void
}

export const useNewAccountStore = create(
  persist<NewAccountState>(
    (set) => ({
      step: 1,
      userData: {},
      responsibleData: {},
      businessData: {},
      setStep: (step) => set({ step }),
      setUserData: (data) => set({ userData: data }),
      setResponsibleData: (data) => set({ responsibleData: data }),
      setBusinessData: (data) => set({ businessData: data }),
      reset: () => set({ step: 1, userData: {}, responsibleData: {}, businessData: {} }),
    }),
    {
      name: 'new-account-storage',
    }
  )
) 